<template>
<vs-card class="px-4 pt-4 cardx mb-8">
		<div class="vx-row">
			<div class="vx-col md:w-1/4 w-full">
			 	<div class="vx-row mb-6">
			      <div class="vx-col md:w-1/4 w-full">
			        <span>Line ID</span>
			      </div>
			      <div class="vx-col md:w-3/4 w-full">
			        <vs-input class="w-full" v-model="line_id" disabled/>
			      </div>
			    </div>
			    <div class="vx-row mb-6">
			      <div class="vx-col md:w-1/4 w-full">
			        <span>Product</span>
			      </div>
			      <div class="vx-col md:w-3/4 w-full">
			        <!-- <vs-input class="w-full" v-model="product_id" /> -->
			          <!-- <label for="" class="vs-input--label">Warehouse</label> -->
				     <v-select :options="productOption" v-model="product" class="" @input="setSelectedProduct" :disabled="!on_edit"></v-select>
			      </div>
			    </div>
			    <div class="vx-row mb-6">
			      <div class="vx-col md:w-1/4 w-full">
			        <span>Descriptions</span>
			      </div>
			      <div class="vx-col md:w-3/4 w-full">
			        <vs-input class="w-full" v-model="descriptions" disabled/>
			      </div>
			    </div>
			</div>
			<div class="vx-col md:w-2/5 w-full">
				<div class="vx-row">
				 	<div class="vx-col md:w-1/2">
					 	<div class="vx-row mb-6">
					      <div class="vx-col md:w-1/3 w-full">
					        <span>Pack ID</span>
					      </div>
					      <div class="vx-col md:w-2/3 w-full">
					        <vs-input class="w-full" v-model="pack_id"  :disabled="!on_edit" />
					      </div>
					 	</div>
				    </div>
				    <div class="vx-col md:w-1/2">
					    <div class="vx-row mb-6">
					      <div class="vx-col md:w-1/3 w-full">
					        <span>Batch</span>
					      </div>
					      <div class="vx-col md:w-2/3 w-full">
					        <vs-input class="w-full" v-model="batch"  :disabled="!on_edit" />
					      </div>
					    </div>
				    </div>
			    </div>
			    <div class="vx-row mb-6">
			      <div class="vx-col md:w-1/6 w-full">
			        <span>Exp. Date</span>
			      </div>
			      <div class="vx-col md:w-5/6 w-full">
			        <flat-pickr class="vs-inputx vs-input--input " v-model="expired_date"  :disabled="!on_edit" />
			      </div>
			    </div>
				<div class="vx-row">
				 	<div class="vx-col md:w-1/2">
					 	<div class="vx-row mb-6">
					      <div class="vx-col md:w-1/3 w-full">
					        <span>UoM</span>
					      </div>
					      <div class="vx-col md:w-2/3 w-full">
					        <!-- <vs-input class="w-full" v-model="uom_id" /> -->
					         <v-select :options="uomOption" v-model="uom" class="w-full " :disabled="(product == null) || !on_edit ? true : false" @input='inputUom'></v-select>
					      </div>
					 	</div>
				    </div>
				    <div class="vx-col md:w-1/2">
					    <div class="vx-row mb-6">
					      <div class="vx-col md:w-1/3 w-full">
					        <span>Qty</span>
					      </div>
					      <div class="vx-col md:w-2/3 w-full">
					        <vs-input class="w-full" v-model="qty" @input="Conversion" 
					        v-on:keyup="keyEnter"
					        :disabled="uom == null || !on_edit ? true : false " />
					      </div>
					    </div>
				    </div>
			    </div>
			</div>
			<div class="vx-col md:w-1/3 w-full">
				<div class="vx-row">
				 	<div class="vx-col md:w-1/2">
					 	<div class="vx-row mb-6">
					      <div class="vx-col md:w-1/2 w-full">
					        <span>Base UoM</span>
					      </div>
					      <div class="vx-col md:w-1/2 w-full">
					        <!-- <vs-input class="w-full" v-model="base_uom" /> -->
					         <v-select :options="baseUomOption" v-model="base_uom" class="w-full " disabled></v-select>
					      </div>
					 	</div>
				    </div>
				    <div class="vx-col md:w-1/2">
					    <div class="vx-row mb-6">
					      <div class="vx-col md:w-1/2 w-full">
					        <span>Base Qty</span>
					      </div>
					      <div class="vx-col md:w-1/2 w-full">
					        <vs-input class="w-full" v-model="base_qty" disabled />
					      </div>
					    </div>
				    </div>
			    </div>
			 	<div class="vx-row mb-6">
			      <div class="vx-col md:w-1/4 w-full">
			        <span>Open Qty</span>
			      </div>
			      <div class="vx-col md:w-3/4 w-full">
			        <vs-input class="w-full" v-model="open_qty" disabled />
			      </div>
			    </div>
			    <div class="vx-row mb-6">
			      <div class="vx-col md:w-1/4 w-full">
			        <span>Recv Qty</span>
			      </div>
			      <div class="vx-col md:w-3/4 w-full">
			        <vs-input class="w-full" v-model="recv_qty" disabled />
			      </div>
			    </div>
			</div>
			<!-- {{ JSON.stringify(product) }}
			{{ JSON.stringify(uom) }}
			{{ JSON.stringify(qty) }} -->
			<!-- {{ convQty }} -->

		</div>
		<div slot="footer" class="pt-4">
          <vs-row vs-justify="center">
            <vs-button class="mr-2" color="primary" @click="editItem()" v-show="!on_edit">Edit</vs-button>
            <vs-button class="mr-2" color="warning" @click="removeItem()" v-show="!on_edit">Delete</vs-button>
            <vs-button class="mr-2" color="success" @click="saveItem()" v-show="on_edit">Save</vs-button>
            <vs-button color="danger" @click="cancelEdit()" v-show="on_edit">Cancel</vs-button>
          </vs-row>
		</div>
	</vs-card>
</template>

<script type="text/javascript">
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
	import 'flatpickr/dist/flatpickr.css';
	
	export default {
		name:'inbound-item',
		 props: {
		    client_id: {
		      type: Number,
		      description: "Whether input is required (adds an asterix *)"
		    },
		    item_product: {
		      type: Object,
		      description: "Whether input is required (adds an asterix *)"
		    },
		},
		components:{
			vSelect,
			flatPickr,
		},
		data(){
			return {
					on_edit:true,
					is_exist:false,
					id:'',
					line_id:1,
					old_client_id:'',
					product:null,
					productOption:[],
					descriptions:'',
					pack_id:'',
					batch:'',
					expired_date:'',
					uom:null,
					uomOption:[],
					qty:0,
					base_uom:null,
					baseUomOption:[],
					base_qty:'',
					open_qty:'',
					recv_qty:0,
					// convQty:'',
					itemData:{},
			}
		},
		mounted(){
			this.id = this._uid;
	        let id = this.$props.client_id;
	        let item = this.$props.item_product;

	        console.log(item);

	        if(item != null){
	        	  this.id = item.id;
	        	  this.line_id = item.line_id;
	              this.product = {...item.product, label:item.product.product_code,};
	              this.descriptions = item.product.description_1;
	              this.pack_id = item.pack_id;
	              this.batch = item.batch;
	              this.expired_date = item.expired_date;
	              this.qty = item.qty;
	              this.uom = {...item.uom, label:item.uom.name,};
	              this.open_qty = item.open_qty;
	              this.recv_qty = item.recv_qty;
	              this.base_qty = item.base_qty;
	              this.base_uom =  {...item.base_uom, label:item.base_uom.name,};
	        	  this.on_edit = false;
	        }

			    function getProductClient(ax) {
			      return ax.get('/master/product/'+id+'/showbyclient');
			    }

			    this.$http.all([getProductClient(this.$http)])
			      .then(this.$http.spread((product) => {
			          for(let i = 0; i < product.data.length; i++){
			              this.productOption.push({...product.data[i], label:product.data[i].product_code,}); 
			          }
			      }));

		},
		watch: {

		},
		methods:{
			saveItem(){
			if(this.qty != 0){
	            let itemData = {
	                  line_id:this.line_id,
	                  product_id:this.product.id,
	                  pack_id:this.pack_id,
	                  batch:this.batch,
	                  expired_date:this.expired_date,
	                  qty:this.qty,
	                  uom_id:this.uom.id,
	                  open_qty:this.open_qty,
	                  recv_qty:this.recv_qty,
	                  base_qty:this.base_qty,
	                  base_uom_id:this.base_uom.id,
	                  status:'insert',
	                  stock_type_id:1,
	            	};					
					this.$emit('item_detail', {item_id:this.$vnode.key, data:itemData});
					this.on_edit = false;
			}

			},
		    removeItem () {
		      // destroy the vue listeners, etc
		      // this.$destroy();
		      // remove the element from the DOM
        	    this.$vs.dialog({
			        type: 'confirm',
			        color: 'danger',
			        title: `Confirm`,
			        text: 'Are you sure want to Delete this product ?',
			        accept: this.acceptAlert
			      });
		    },
		    editItem () {
		    	this.on_edit = true;
		    	this.is_exist = true;
		    },
		    cancelEdit () {
		    	this.on_edit = false;
		    	if(!this.is_exist){
		    		this.$el.parentNode.removeChild(this.$el);
		    	}
		    },
	        acceptAlert() {
		      this.$vs.notify({
		        color: 'success',
		        title: 'Deleted product',
		        iconPack: 'feather',
        		icon:'icon-check',
		        text: 'The selected product was successfully deleted'
		      });
		       this.$el.parentNode.removeChild(this.$el);
		       this.$emit('delete_id', this.$vnode.key);
		  	},
		  	keyEnter: function(e){
		  		 if (e.keyCode === 13) {
		  		 	this.saveItem();
		  		 }
		  	},
		  	inputUom(value){
		  		if(value == null){
		  			this.qty = 0;
		  			this.base_qty = 0;
		  			this.open_qty = 0;
		  			this.uom = null;
		  		}
		  		if(this.qty != ''){
					let cdata = {
		                'product_id': this.product.id,
		                'uoms_id': this.uom.id,
		                'qty': this.qty,
		              };
		            // console.log(JSON.stringify(cdata));
				    this.$http.post('/inbound/conversion', cdata ).then((resp) => {
		              	// console.log(resp);
		              	this.base_qty = resp.data;
		              	this.open_qty = resp.data;
			        })
			        .catch((resp) =>{
			          console.log(resp.response);
			        });
		    	}
		  	},
		    Conversion : function(){
		    	if(this.qty != ''){
					let cdata = {
		                'product_id': this.product.id,
		                'uoms_id': this.uom.id,
		                'qty': this.qty,
		              };
		            // console.log(JSON.stringify(cdata));
				    this.$http.post('/inbound/conversion', cdata ).then((resp) => {
		              	// console.log(resp);
		              	this.base_qty = resp.data;
		              	this.open_qty = resp.data;
			        })
			        .catch((resp) =>{
			          console.log(resp.response);
			        });
		    	}
			},
		    setSelectedProduct(value) {
		    	if(value != null){

				this.descriptions = value != null ? value.description_1 : '';
				this.$http.get('/master/product/'+value.id)
				  .then((response) =>  {
				  	let prd = response.data; 
			          this.uomOption = [];
			          this.baseUomOption = [];
			          for(let i = 0; i < prd.uoms.length; i++){
			              this.uomOption.push({...prd.uoms[i].uom, label:prd.uoms[i].uom.name,});
			          }
			              // console.log("base_uom : "+JSON.stringify(prd.default_uom.uom.name)); 
			              this.baseUomOption.push({...prd.default_uom.uom, label:prd.default_uom.uom.name,});
			              this.base_uom = {...prd.default_uom.uom, label:prd.default_uom.uom.name,} ;
				  })
				  .catch(function (error) {
				    console.log(error);
				  });
		          
		    	}else{
		    		 this.uom = null;
		    		 this.uomOption = [];
			         this.base_uom = null;
			         this.baseUomOption = [];
			         this.descriptions = '';
		    	}
     		}
		}

	}	
</script>

<!-- 
    $('#INBOUND_TABLE_DETAIL tbody tr').each(function() {
            td = $(this).find('td');
            let obj ={
                  line_id:td[0].innerHTML,
                  product_id:$(td[1]).attr('data-id'),
                  pack_id:td[3].innerHTML,
                  batch:td[4].innerHTML,
                  expired_date:td[5].innerHTML,
                  qty:td[6].innerHTML,
                  uom_id:$(td[7]).attr('data-id'),
                  open_qty:td[8].innerHTML,
                  recv_qty:0,
                  base_qty:td[10].innerHTML,
                  base_uom_id:$(td[11]).attr('data-id'),
                  status:$(this).attr('data-status'),
                  stock_type_id:1,
            };
            list_detail.push(obj);
      });


 -->